import styled from 'styled-components'

export const Iframe = styled.iframe<{ isModelStarted: boolean }>`
  width: 100%;
  height: ${({ isModelStarted }) => (isModelStarted ? '100%' : '50%')};
`
